import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'Components/Button';
import Icon from 'Components/Icon';
import CombinationFailMessage from './Partitions/CombinationFailMessage';
import EnvironmentManager from 'Utils/environmentManager';
import BetPill from '../../Pills/BetPill';
import { addEventVerifyRecommended, removeEventFromBetSlip } from 'Store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { generateSportTypeIcons } from 'Utils/generateSportTypeIcons';
import mixpanel from 'Utils/mixpanel';

const PlaySuccessRecommendModal = ({
  couponDetails,
  playCouponState
}) => {

  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const betSlip = useSelector(state => state.betSlip);
  const titleRow1 = EnvironmentManager.getMessageText({ key: 'prof_bahista_lite_table_row_1' });
  const titleRow2 = EnvironmentManager.getMessageText({ key: 'prof_bahista_lite_table_row_2' });
  const titleRow1Arr = titleRow1.split('%@');
  const titleRow2Arr = titleRow2.split('%@');

  const banner_title = EnvironmentManager.getMessageText({ key: 'csp_coupon_boost' }) || '<b>Profesör Bahista</b>’nın Önerisiyle Kuponun Hesaplanan Tutma İhtimali’ni yükselt.';
  const csp_why_recommending = EnvironmentManager.getMessageText({ key: 'csp_why_recommending' }) || 'Neden Öneriyor';

  const csp_previous_probability = EnvironmentManager.getMessageText({ key: 'csp_previous_probability' }) || 'Kuponun öneri öncesi tutma ihtimali (%@)';
  const csp_next_probability = EnvironmentManager.getMessageText({ key: 'csp_next_probability' }) || 'Kuponun Prof. Bahista önerisi sonrası tutma ihtimali (%@)';


  const { recommendedData } = playCouponState || {};
  const { totalCost, probability, sportId, eventId, eventName, playedCouponDetail, recommendedCouponDetail, mbs } = recommendedData || {};


  useEffect(() => {
    mixpanel.track('View Success Recommended Pop-up', {
      'Teams List': [eventName]
    });
  }, []);

  const events = {
    eventId: eventId,
    marketId: recommendedCouponDetail?.marketId,
    marketOutcomeNo: recommendedCouponDetail?.marketOutcomeId
  };
  const oddId = `${events.eventId}:${events.marketId}:${events.marketOutcomeNo}`;

  const isSelected = couponDetails.some(coupon => {
    return coupon.id === oddId;
  }) || betSlip.couponDetails.some(coupon => {
    return coupon.bets[0].id === oddId;
  });

  const toggleAction = () => {
    !isSelected
      ? dispatch(addEventVerifyRecommended({
        eventId,
        event: recommendedCouponDetail,
        recommendedCost: recommendedCouponDetail?.multiplier,
        recommendedMultiCouponCount: recommendedCouponDetail?.requestedMultiCouponCount
      }))
      : dispatch(removeEventFromBetSlip(oddId));
  };

  const togglePlayCouponAction = () => {
    dispatch(addEventVerifyRecommended({
      eventId,
      event: recommendedCouponDetail,
      recommendedCost: recommendedCouponDetail?.multiplier,
      recommendedMultiCouponCount: recommendedCouponDetail?.requestedMultiCouponCount
    }));
  };
  const professionIcons = generateSportTypeIcons;

  return (
    <div className="play-coupon-success-modal recommended">
      <CombinationFailMessage data={ playCouponState } alignCenter />
      <>
        <div className="recommended-comments__row">
          <div className="recommended-comments__row__comment">
            <div className="recommended-comments__row__banner">
              <img className="recommended-comments__row__banner__avatar"
                src='/public/images/csp-bahista-avatar.png'
                alt='/public/images/csp-bahista-avatar.png'/>
              <div className="recommended-comments__row__banner__content">
                <div className="recommended-comments__row__banner_text" dangerouslySetInnerHTML={ { __html: banner_title } }/>
                <div className="recommended-comments__row__banner__stats">
                  <span className="recommended-comments__row__banner__percentage recommended-comments__row__banner__percentage--old">
                    { csp_previous_probability.replace('@',  Math.round(playedCouponDetail?.probability * 100) ) }
                  </span>
                  <img
                    src='/public/loaders/csp-bahista-animation.gif'
                    alt="animation"
                    className="recommended-comments__row__banner__arrow"
                  />
                  <span className="recommended-comments__row__banner__percentage recommended-comments__row__banner__percentage--new">
                    { csp_next_probability.replace('@', Math.round(probability * 100) ) }
                  </span>
                </div>
              </div>
            </div>
            <div className="recommended-comments__row__detail">
              <img
                className="recommended__row__leagues__profession"
                src={ professionIcons(sportId) }
              />{ eventName }
            </div>
            <div className="recommended-comments__row__event">
              <div className="recommended-comments__row__pills">
                <div
                  className="recommended-comments__row__pills-title">{ recommendedCouponDetail?.marketName }</div>
                <div className="recommended-comments__row__pills-pill">
                  <Icon iconName={ mbs > 4 ? 'iconMbs4Betslip' : `iconMbs${mbs}Betslip` }/>
                  <BetPill
                    pillStyle="horizontal"
                    odd={ recommendedCouponDetail?.fixedOddsWeb }
                    betType={ recommendedCouponDetail?.label || recommendedCouponDetail?.marketOutcomeName }
                    isSelected={ isSelected }
                    onClick={ () => toggleAction() }
                  />
                </div>
              </div>
              <Button title={ 'HEMEN OYNA' } className='btn--primary btn--half-round recommended-comments__row__playButton' onClick={ () => togglePlayCouponAction()  }>
                <span> { `${( recommendedCouponDetail?.multiplier * recommendedCouponDetail?.requestedMultiCouponCount )} TL - OYNA` }</span>
              </Button>
            </div>
            <div
              className="recommended-comments__row__collapse-toggle"
              onClick={ () => setIsOpen(prev => !prev) }
            >
              <span className="collapse-toggle__text">{ csp_why_recommending }</span>
              <Icon
                iconName={ isOpen ? 'svgUpDirection' : 'svgDownDirection' }
              />
            </div>
            {
              isOpen
              && <div className="recommended-comments__row__commentDesc">
                <div style={ { overflowX: 'auto', height: '150px' } }>
                  <table className="custom-table">
                    <thead>
                      <tr>
                        <th/>
                        <th
                          dangerouslySetInnerHTML={ { __html: EnvironmentManager.getMessageText({ key: 'prof_bahista_lite_table_column_1' }) } }/>
                        <th
                          dangerouslySetInnerHTML={ { __html: EnvironmentManager.getMessageText({ key: 'prof_bahista_lite_table_column_2' }) } }/>
                        <th
                          dangerouslySetInnerHTML={ { __html: EnvironmentManager.getMessageText({ key: 'prof_bahista_lite_table_column_3' }) } }/>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          dangerouslySetInnerHTML={ { __html: `${titleRow1Arr[0]}${playedCouponDetail?.label || ''}${titleRow1Arr[1]}`.replace(/<br\s*\/?>/gi, '') } }/>
                        <td>{ playedCouponDetail?.cost } TL</td>
                        <td>{ playedCouponDetail?.expectedWinAmount.toFixed() } TL</td>
                        <td>% { Math.round(playedCouponDetail?.probability * 100) }</td>
                      </tr>
                      <tr>
                        <td
                          dangerouslySetInnerHTML={ { __html: `${titleRow2Arr[0]}${recommendedCouponDetail?.label || ''}${titleRow2Arr[1]}`.replace(/<br\s*\/?>/gi, '') } }
                        />
                        <td>{ recommendedCouponDetail?.multiplier * recommendedCouponDetail?.requestedMultiCouponCount } TL</td>
                        <td>{ recommendedCouponDetail?.expectedWinAmount.toFixed() } TL</td>
                        <td>% { Math.round(recommendedCouponDetail?.probability * 100) }</td>
                      </tr>
                      <tr className="highlight-row">
                        <td
                          dangerouslySetInnerHTML={ { __html: EnvironmentManager.getMessageText({ key: 'prof_bahista_lite_table_row_3' }).replace(/<br\s*\/?>/gi, '') } }/>
                        <td>{ totalCost } TL</td>
                        <td>{ playedCouponDetail?.expectedWinAmount.toFixed() } TL
                        - { recommendedCouponDetail?.expectedWinAmount.toFixed() } TL
                        </td>
                        <td>% { Math.round(probability * 100) }</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            }
          </div>
        </div>
      </>
    </div>
  );
};
PlaySuccessRecommendModal.propTypes = {
  couponDetails: PropTypes.array.isRequired,
  playCouponState: PropTypes.object.isRequired
};

export default PlaySuccessRecommendModal;
